import { api } from "./api";

export const loginApi = (params) => {
    return api.post(`/auth/login`, JSON.stringify(params));
};